import { css } from '@emotion/react';

export default $ => css`
  .modal > .modal-dialog {
    &.modal-primary > .modal-content > .modal-header {
      background-color: ${$.primaryMain};
      color: ${$.white};
    }

    &.modal-primary > .modal-content > .modal-header > .close {
      opacity: 0.8;
      text-shadow: none;
    }

    &.modal-primary > .modal-content > .modal-header > .close:hover {
      opacity: 1;
    }

    &.modal-primary > .modal-content > .modal-header > .close > span {
      color: ${$.white};
      font-size: 2rem;
      opacity: 1;
      text-shadow: none;
    }

    > .modal-content {
      border-radius: ${$.borderRadius};

      > .modal-header {
        border-top-left-radius: ${$.borderRadius};
        border-top-right-radius: ${$.borderRadius};
      }
    }

    &.maximized {
      max-width: 96vw;
      max-height: 96vh;
      height: 94%;
      margin: 2%;
      display: flex;

      > .modal-content {
        justify-content: stretch;
        max-height: 96vh;
      }
    }
  }
`;
